import Ajv from "ajv/lib/ajv";

// https://ajv.js.org/#options

const ajv = new Ajv({
  format: "full",
  allErrors: true,
  verbose: true,
  data: true,
  removeAdditional: true
});

export default ajv;
